<template>
    <div class="hero-imgs">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <div class="hero-imgs__img">
                        <img loading="lazy" width="445" height="314" src="/img/descubre-santiago.png"
                            alt="Descubre Santiago">
                    </div>
                </div>
                <div class="col-md-6 offset-md-1">
                    <div class="hero-imgs__img img-der">
                        <img loading="lazy" width="450" height="358" src="/img/hero-turismo-lugares-interes.png"
                            alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style>

</style>
